<template>
  <Page>
    <div class="pageContent-title">订单列表</div>
    <!-- 基本信息 -->
    <div class="infoView-box">
      <div class="info-title">基本信息</div>
      <div class="info-content">
        <a-form class="flex-form form-label-4" :form="order">
          <a-form-item label="状态">
            <span>
              <!-- 审核异议: -1, 待完善: 0, 待初审: 5, 待OP审核: 10, 待结算: 15, // 审核完成, 已结账: 20, -->
              {{
                order.status == -1
                  ? '审核异议'
                  : order.status == 0
                  ? '待完善'
                  : order.status == 5
                  ? '待初审'
                  : order.status == 10
                  ? '审核中'
                  : order.status == 15
                  ? '审核完成'
                  : order.status == 20
                  ? '已结账'
                  : ''
              }}
            </span>
          </a-form-item>
          <div class="grid grid-cols-3 xl:grid-cols-4 gap-2">
            <a-form-item label="导游">
              <span>{{ order.touristGuideName }}</span>
            </a-form-item>
            <a-form-item label="团号">
              <span>{{ order.teamNumber }}</span>
            </a-form-item>
            <a-form-item label="方案号">
              <span>{{ order.planNumber }}</span>
            </a-form-item>
            <a-form-item label="地区">
              <span>{{ order.region }}</span>
            </a-form-item>
            <a-form-item label="创建时间">
              <span>{{ order.createTime }}</span>
            </a-form-item>
            <a-form-item label="提交时间">
              <span>{{ order.submitTime }}</span>
            </a-form-item>
            <a-form-item label="结账时间">
              <span>{{ order.closingTime ? order.closingTime : '---' }}</span>
            </a-form-item>
            <a-form-item label="OP">
              <span>{{ order.guideOpUserName ? order.guideOpUserName : '---' }}</span>
            </a-form-item>
          </div>
        </a-form>
      </div>
    </div>
    <a-divider></a-divider>
    <!-- 供应商信息 -->
    <div class="infoView-box">
      <div class="info-title">结账信息</div>
      <div class="info-content">
        <a-form class="flex-form form-label-5" :form="order">
          <div class="grid grid-cols-3 2xl:grid-cols-4 gap-2">
            <a-form-item label="人数">
              <span>
                {{
                  Number(order.adultsNum) +
                    Number(order.oldNum) +
                    Number(order.studentsNum) +
                    Number(order.babyNum) +
                    Number(order.tcNum)
                }}
              </span>
            </a-form-item>
            <a-form-item label="管理费">
              <span>{{ order.managementFee }}</span>
            </a-form-item>
          </div>
        </a-form>
      </div>
    </div>
    <a-divider></a-divider>

    <div class="infoView-box">
      <div class="info-title">
        <span style="flex: 1">现收团款</span>
        {{ cashReceiptsAmount }} 美元
      </div>
      <div class="info-content" style="display: flex">
        <TableModel :header="currentGroupCostHeader" :form="order.currentGroupCostDetails"></TableModel>
      </div>
      <div v-if="order.status == 5 || order.status == 10" style="margin-top:20px">
        <button
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.groupCostStatus == 0 && 'active1']"
          @click="selectSuccess('groupCostStatus')"
        >
          审核通过
        </button>
        <button
          type="danger"
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.groupCostStatus == 1 && 'active']"
          @click="selectLose('groupCost')"
        >
          审核失败
        </button>
        <span v-if="examine.groupCostReason" style="margin-left: 30px">失败原因: {{ examine.groupCostReason }}</span>
      </div>
    </div>

    <a-divider></a-divider>
    <div class="infoView-box">
      <div class="info-title">
        <span style="flex: 1">购物信息</span>
        {{ shopAmount.count1 }} 人民币
      </div>
      <div class="info-content">
        <TableModel :header="shoppingHeader" :form="order.shoppingDetails"></TableModel>
      </div>
      <div v-if="order.status == 5 || order.status == 10" style="margin-top:20px">
        <button
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.shoppingStatus == 0 && 'active1']"
          @click="selectSuccess('shoppingStatus')"
        >
          审核通过
        </button>
        <button
          type="danger"
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.shoppingStatus == 1 && 'active']"
          @click="selectLose('shopping')"
        >
          审核失败
        </button>
        <span v-if="examine.shoppingReason" style="margin-left: 30px">失败原因: {{ examine.shoppingReason }}</span>
      </div>
    </div>
    <a-divider></a-divider>
    <div class="infoView-box">
      <div class="info-title">
        <span style="flex: 1">景点信息</span>
        {{ scenicAmount }}元
      </div>
      <div class="info-content" style="display: flex">
        <TableModel :header="scenicSpotHeader" :form="order.scenicSpotDetails"></TableModel>
      </div>
      <div v-if="order.status == 5 || order.status == 10" style="margin-top:20px">
        <button
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.scenicSpotStatus == 0 && 'active1']"
          @click="selectSuccess('scenicSpotStatus')"
        >
          审核通过
        </button>
        <button
          type="danger"
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.scenicSpotStatus == 1 && 'active']"
          @click="selectLose('scenicSpot')"
        >
          审核失败
        </button>
        <span v-if="examine.scenicSpotReason" style="margin-left: 30px">失败原因: {{ examine.scenicSpotReason }}</span>
      </div>
    </div>
    <a-divider></a-divider>
    <div class="infoView-box">
      <div class="info-title">
        <span style="flex: 1">餐厅信息</span>
        {{ restaurantAmount }}元
      </div>
      <div class="info-content" style="display: flex">
        <TableModel :header="restaurantHeader" :form="order.restaurantDetails"></TableModel>
      </div>
      <div v-if="order.status == 5 || order.status == 10" style="margin-top:20px">
        <button
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.restaurantStatus == 0 && 'active1']"
          @click="selectSuccess('restaurantStatus')"
        >
          审核通过
        </button>
        <button
          type="danger"
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.restaurantStatus == 1 && 'active']"
          @click="selectLose('restaurant')"
        >
          审核失败
        </button>
        <span v-if="examine.restaurantReason" style="margin-left: 30px">失败原因: {{ examine.restaurantReason }}</span>
      </div>
    </div>
    <a-divider></a-divider>
    <div class="infoView-box">
      <div class="info-title">
        <span style="flex: 1">酒水果篮信息</span>
        {{ shoppingAmount }}元
      </div>
      <div class="info-content" style="display: flex">
        <TableModel :header="wineFruitBasketHeader" :form="order.wineFruitBasketDetails"></TableModel>
      </div>
      <div v-if="order.status == 5 || order.status == 10" style="margin-top:20px">
        <button
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.wineFruitBasketStatus == 0 && 'active1']"
          @click="selectSuccess('wineFruitBasketStatus')"
        >
          审核通过
        </button>
        <button
          type="danger"
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.wineFruitBasketStatus == 1 && 'active']"
          @click="selectLose('wineFruitBasket')"
        >
          审核失败
        </button>
        <span v-if="examine.wineFruitBasketReason" style="margin-left: 30px">
          失败原因: {{ examine.wineFruitBasketReason }}
        </span>
      </div>
    </div>
    <a-divider></a-divider>
    <div class="infoView-box">
      <div class="info-title">
        <span style="flex: 1">酒店信息</span>
        {{ hotelAmount }}元
      </div>
      <div class="info-content" style="display: flex">
        <TableModel :header="hotelHeader" :form="order.hotelDetails"></TableModel>
      </div>
      <div v-if="order.status == 5 || order.status == 10" style="margin-top:20px">
        <button
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.hotelStatus == 0 && 'active1']"
          @click="selectSuccess('hotelStatus')"
        >
          审核通过
        </button>
        <button
          type="danger"
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.hotelStatus == 1 && 'active']"
          @click="selectLose('hotel')"
        >
          审核失败
        </button>
        <span v-if="examine.hotelReason" style="margin-left: 30px">失败原因: {{ examine.hotelReason }}</span>
      </div>
    </div>
    <a-divider></a-divider>
    <div class="infoView-box">
      <div class="info-title">
        <span style="flex: 1">车费服务费等信息</span>
        {{ carAmount }}元
      </div>
      <div class="info-content" style="display: flex">
        <TableModel :header="wineFruitBasketHeader" :form="order.carServiceFeeDetails"></TableModel>
      </div>
      <div v-if="order.status == 5 || order.status == 10" style="margin-top:20px">
        <button
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.carServiceFeeStatus == 0 && 'active1']"
          @click="selectSuccess('carServiceFeeStatus')"
        >
          审核通过
        </button>
        <button
          type="danger"
          style="margin-left:20px;border:1px solid #dfdfdf;height: 42px;width:200px;border-radius:20px"
          :class="[examine.carServiceFeeStatus == 1 && 'active']"
          @click="selectLose('carServiceFee')"
        >
          审核失败
        </button>
        <span v-if="examine.carServiceFeeReason" style="margin-left: 30px">
          失败原因: {{ examine.carServiceFeeReason }}
        </span>
      </div>
    </div>
    <a-divider></a-divider>
    <!-- 备注信息 -->
    <div class="infoView-box">
      <div class="info-title">美金/韩元是否抵扣团款</div>
      <div class="info-content">
        <p v-if="order.usdDeductAmount">
          抵扣金额($):{{ order.usdDeductAmount }} 折合人民币:{{
            Number(order.usdDeductAmount) * Number(order.usdExchange)
          }}
        </p>
        <!-- <p v-if="order.krwDeductAmount">
          抵扣金额($):{{ order.krwDeductAmount }} 折合人民币:{{
            Number(order.krwDeductAmount) * Number(order.krwExchange)
          }}
        </p> -->
        <p>提交时汇率:</p>
        <p>
          美元:{{ order.usdExchange }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 韩元:{{
            order.krwExchange
          }}
        </p>
      </div>
    </div>
    <a-divider></a-divider>
    <!-- 备注信息 -->
    <div class="infoView-box">
      <div class="info-title">备注信息</div>
      <div class="info-content">
        <p>{{ order.remark }}</p>
      </div>
    </div>
    <a-divider></a-divider>
    <!-- 支付信息 -->
    <div class="infoView-box">
      <div class="info-title">结账</div>
      <div>
        <a-row :gutter="30">
          <a-col :span="8">
            <p style="line-height: 32px">
              全部金额：{{
                (ticketAmount.count1 + ticketAmount.count2 - order.usdDeductAmount * order.usdExchange).toFixed(2)
              }}
            </p>
          </a-col>
          <a-col :span="8">
            <p style="line-height: 32px">
              有票金额：{{
                ticketAmount.count1 | myFilter2(ticketAmount.count2, order.usdDeductAmount, order.usdExchange)
              }}
            </p>
          </a-col>
          <a-col :span="8">
            <p style="line-height: 32px">
              无票金额：{{ ticketAmount.count2 | myFilter1(order.usdDeductAmount, order.usdExchange) }}
            </p>
          </a-col>
        </a-row>
        <a-row :gutter="30">
          <a-col :span="8">
            <p>购物合计：{{ shopAmount.count1 }}</p>
          </a-col>
          <a-col :span="8">
            <p>抵扣团款金额：{{ order.usdDeductAmount }}</p>
          </a-col>
          <a-col :span="8">
            <p>抵扣团款金额折合人民币：{{ (order.usdDeductAmount * order.usdExchange).toFixed(2) }}</p>
          </a-col>
        </a-row>
        <a-row :gutter="30">
          <a-col :span="8" style="display: flex">
            <p style="width: 120px; line-height: 32px">应收导游：</p>
            <a-input v-model="order.guideFeeToReceive" :disabled="order.status == 20"></a-input>
          </a-col>
          <a-col :span="8" style="display: flex">
            <a-input v-model="order.usdAmountToReceive" addon-after="$" :disabled="order.status == 20"></a-input>
          </a-col>
          <a-col :span="8" style="display: flex">
            <a-input v-model="order.krwAmountToReceive" addon-after="₩" :disabled="order.status == 20"></a-input>
          </a-col>
        </a-row>
        <a-row :gutter="30">
          <a-col :span="8" style="display: flex">
            <p style="width: 120px; line-height: 32px">应付导游:</p>
            <a-input v-model="order.guideFeeToPay" :disabled="order.status == 20"></a-input>
          </a-col>
          <a-col :span="8" style="display: flex">
            <a-button v-if="order.status != 20" class="app-btn" type="primary" @click="saveRebate">
              填写购物返利信息
            </a-button>
            <a-button
              v-if="order.status != 20"
              class="app-btn"
              type="primary"
              style="margin-left: 20px"
              @click="getAmount"
            >
              计算
            </a-button>
          </a-col>
        </a-row>
        <p style="color: red">*注：计算结果仅供参考</p>
        <a-row :gutter="30">
          <a-col :span="12" style="display: flex">
            <p>
              实
              <span style="color: red">{{ amount > 0 ? '付' : '收' }}</span>
              导游:
            </p>
            <span style="margin-left: 20px">{{ amount > 0 ? amount : -amount }}</span>
            元
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="detailView-actions" style="width: 100%; text-align: center">
      <a-button v-if="order.status == 5" class="app-btn" type="primary" @click="examine1Ok">初审完成</a-button>
      <a-button v-if="order.status == 10" class="app-btn" type="primary" @click="examine2Ok">待OP审核完成</a-button>
      <a-button v-if="order.status == 15 || order.status == 20" class="app-btn" type="primary" @click="downloadFile">
        下载结账单
      </a-button>
      <a-button v-if="order.status == 15" class="app-btn" type="default" style="margin-left: 20px" @click="goBack">
        已线下结账
      </a-button>
      <a-button
        v-if="order.status == 15 || order.status == 20"
        class="app-btn"
        type="primary"
        style="margin-left: 20px"
        @click="backOrder"
      >
        审核失败
      </a-button>
    </div>
    <a-divider></a-divider>
    <div>
      <div class="pageContent-title">操作日志</div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          rowKey="(record, index)=>{return index}"
          bordered
          :loading="tableLoading"
          :scroll="{ x: 1400 }"
          :columns="tableColumns"
          :dataSource="dataSource"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
    <a-modal v-model="rebateVisible" title="返利信息" @cancel="handleCancel" @ok="handleOk">
      <div>
        <div v-for="(item, index) in order.shoppingDetails" :key="index">
          <p>项目: {{ item.item }}</p>
          <p>
            返利比例:
            <a-input-number
              v-model="item.rebate"
              style="width: 200px"
              :min="0"
              :max="100"
              placeholder="请输入1-100数值"
            ></a-input-number>
            %
          </p>
        </div>
      </div>
      <template v-slot:footer>
        <a-button @click="handleOk" type="primary">确定</a-button>
      </template>
    </a-modal>

    <a-modal v-model="reasonModal" title="失败原因" width="30%" @cancel="handleCancel">
      <div style="display: flex; justify-content: center; align-items: center; width: 100%">
        <a-textarea
          v-model="reasonName"
          placeholder="请输入审核失败原因"
          :auto-size="{ minRows: 6, maxRows: 12 }"
        ></a-textarea>
      </div>
      <template v-slot:footer>
        <a-button @click="reasonOk" type="primary">确定</a-button>
      </template>
    </a-modal>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import TableModel from '@/components/table-model'
export default {
  components: {
    Page,
    TableModel,
  },
  filters: {
    myFilter1(t1, t2, t3) {
      if ((Number(t1) - Number(t2) * Number(t3)).toFixed(2) <= 0) {
        return 0
      } else {
        return (Number(t1) - Number(t2) * Number(t3)).toFixed(2)
      }
    },
    myFilter2(t1, t2, t3, t4) {
      if ((Number(t2) - Number(t3) * Number(t4).toFixed(2)).toFixed(2) > 0) {
        return t1
      } else {
        return (Number(t1) - (Number(t2) - Number(t3) * Number(t4).toFixed(2)).toFixed(2)).toFixed(2)
      }
    },
  },
  data() {
    const columns = [
      {
        title: '项目',
        dataIndex: 'item',
        scopedSlots: { customRender: 'item' },
      },
      {
        title: '价格',
        dataIndex: 'totalAmount',
        scopedSlots: { customRender: 'totalAmount' },
      },
    ]
    return {
      tableColumns: [
        {
          title: '序号',
          width: '5%',
          align: 'center',
          customRender: (text, row, index) => {
            return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
          },
        },
        {
          title: '操作时间',
          width: '20%',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '操作内容',
          width: '60%',
          align: 'center',
          customRender: (text, row) => {
            return <span>{row.operation}</span>
          },
        },
        {
          title: '操作人',
          width: '15%',
          align: 'center',
          dataIndex: 'userName',
        },
      ],
      tableLoading: false,
      reasonModal: false,
      countTotal: null,
      dataSource: [],
      reasonName: '',
      statusInfo: {
        审核异议: -1,
        待完善: 0,
        待初审: 5,
        待OP审核: 10,
        待结算: 15, // 审核完成,
        已结账: 20,
      },
      examine: {
        id: null,
        guideFeeToReceive: null,
        guideFeeToPay: null,
        groupCostStatus: null,
        groupCostReason: '',
        shoppingStatus: null,
        shoppingReason: '',
        scenicSpotStatus: null,
        scenicSpotReason: '',
        restaurantStatus: null,
        restaurantReason: '',
        wineFruitBasketStatus: null,
        wineFruitBasketReason: '',
        hotelStatus: null,
        hotelReason: '',
        carServiceFeeStatus: null,
        carServiceFeeReason: '',
        version: null,
      },
      imgUrl: '',
      form: this.$form.createForm(this),
      columns: columns,
      order: {},
      pageNumber: 1,
      pageSize: 10,
      imgVisible: false,
      rebateVisible: false,
      currentGroupCostHeader: [
        {
          title: '名称',
        },
        {
          title: '费用',
        },
        {
          title: '人数',
        },
      ],
      shoppingHeader: [
        {
          title: '名称',
        },
        {
          title: '费用',
        },
        {
          title: '有无发票',
        },
        {
          title: '备注',
        },
        {
          title: '发票/收据',
        },
      ],
      scenicSpotHeader: [
        {
          title: '景点',
        },
        {
          title: '类型',
        },
        {
          title: '人数',
        },
        {
          title: '金额',
        },
        {
          title: '有无发票',
        },
        {
          title: '备注',
        },
        {
          title: '发票/收据',
        },
      ],
      restaurantHeader: [
        {
          title: '名称',
        },
        {
          title: '客人餐标',
        },
        {
          title: '客人数',
        },
        {
          title: '司陪餐标',
        },
        {
          title: '司机人数',
        },
        {
          title: '总金额',
        },
        {
          title: '其他金额',
        },
        {
          title: '有无发票',
        },
        {
          title: '备注',
        },
        {
          title: '发票/收据',
        },
      ],
      wineFruitBasketHeader: [
        {
          title: '名称',
        },
        {
          title: '金额',
        },
        {
          title: '有无发票',
        },
        {
          title: '备注',
        },
        {
          title: '发票/收据',
        },
      ],
      hotelHeader: [
        {
          title: '名称',
        },
        {
          title: '用房数',
        },
        {
          title: '司陪房金额',
        },
        {
          title: '客人房金额',
        },
        {
          title: '天数(晚数)',
        },
        {
          title: '有无发票',
        },
        {
          title: '备注',
        },
        {
          title: '发票/收据',
        },
      ],
    }
  },
  computed: {
    ticketAmount() {
      let count1 = 0
      let count2 = 0
      let shoppingCount = 0
      if (this.order.shoppingDetails && this.order.shoppingDetails.length > 0) {
        this.order.shoppingDetails.forEach(e => {
          shoppingCount += Number(e.totalAmount)
        })
      }
      if (this.order.scenicSpotDetails && this.order.scenicSpotDetails.length > 0) {
        this.order.scenicSpotDetails.forEach(e => {
          if (e.hasInvoice == 1) {
            count1 +=
              Number(e.peakFullPriceNum) * Number(e.peakPriceFull) +
              Number(e.peakHalfPriceNum) * Number(e.peakPriceHalf) +
              Number(e.peakStudentNum) * Number(e.peakStudent) +
              Number(e.peakOldNum) * Number(e.peakOld) +
              Number(e.peakFreeNum) * Number(e.peakFree) +
              Number(e.offPeakFullPriceNum) * Number(e.offPeakPriceFull) +
              Number(e.offPeakHalfPriceNum) * Number(e.offPeakPriceHalf) +
              Number(e.offPeakStudentNum) * Number(e.offPeakStudent) +
              Number(e.offPeakOldNum) * Number(e.offPeakOld) +
              Number(e.offPeakFreeNum) * Number(e.offPeakFree)
          } else {
            count2 +=
              Number(e.peakFullPriceNum) * Number(e.peakPriceFull) +
              Number(e.peakHalfPriceNum) * Number(e.peakPriceHalf) +
              Number(e.peakStudentNum) * Number(e.peakStudent) +
              Number(e.peakOldNum) * Number(e.peakOld) +
              Number(e.peakFreeNum) * Number(e.peakFree) +
              Number(e.offPeakFullPriceNum) * Number(e.offPeakPriceFull) +
              Number(e.offPeakHalfPriceNum) * Number(e.offPeakPriceHalf) +
              Number(e.offPeakStudentNum) * Number(e.offPeakStudent) +
              Number(e.offPeakOldNum) * Number(e.offPeakOld) +
              Number(e.offPeakFreeNum) * Number(e.offPeakFree)
          }
        })
      }
      if (this.order.restaurantDetails && this.order.restaurantDetails.length > 0) {
        this.order.restaurantDetails.forEach(e => {
          if (e.hasInvoice == 1) {
            count1 += Number(e.guestStandard) * Number(e.guestCount) + Number(e.guideStandard) * Number(e.guideCount)
            count1 += Number(e.otherAmount)
          } else {
            count2 += Number(e.guestStandard) * Number(e.guestCount) + Number(e.guideStandard) * Number(e.guideCount)
            count2 += Number(e.otherAmount)
          }
        })
      }
      if (this.order.hotelDetails && this.order.hotelDetails.length > 0) {
        this.order.hotelDetails.forEach(e => {
          // count += Number(e.guideRoomAmount) + Number(e.guestRoomAmount)
          if (e.hasInvoice == 1) {
            count1 += (Number(e.guideRoomAmount) + Number(e.guestRoomAmount)) * Number(e.days)
          } else {
            count2 += (Number(e.guideRoomAmount) + Number(e.guestRoomAmount)) * Number(e.days)
          }
        })
      }
      if (this.order.carServiceFeeDetails && this.order.carServiceFeeDetails.length > 0) {
        this.order.carServiceFeeDetails.forEach(e => {
          // count += Number(e.totalAmount)
          if (e.hasInvoice == 1) {
            count1 += Number(e.totalAmount)
          } else {
            count2 += Number(e.totalAmount)
          }
        })
      }
      if (this.order.wineFruitBasketDetails && this.order.wineFruitBasketDetails.length > 0) {
        this.order.wineFruitBasketDetails.forEach(e => {
          // count += Number(e.totalAmount)
          if (e.hasInvoice == 1) {
            count1 += Number(e.totalAmount)
          } else {
            count2 += Number(e.totalAmount)
          }
        })
      }
      const count = shoppingCount > 0 ? shoppingCount : 0
      count2 = count2 + count
      return {
        count1,
        count2,
      }
    },
    amount() {
      if (this.order.guideFeeToPay && this.order.guideFeeToReceive) {
        return (this.order.guideFeeToPay - this.order.guideFeeToReceive).toFixed(2)
      }
      return 0
    },
    cashReceiptsAmount() {
      let count = 0
      if (this.order.currentGroupCostDetails && this.order.currentGroupCostDetails.length > 0) {
        this.order.currentGroupCostDetails.forEach(e => {
          count += Number(e.totalAmount) * Number(e.groupPeople)
        })
      }
      return count
    },
    shopAmount() {
      let count1 = 0
      let count2 = 0
      let count3 = 0
      if (this.order.shoppingDetails && this.order.shoppingDetails.length > 0) {
        this.order.shoppingDetails.forEach(e => {
          if (e.currency == 0) {
            count1 += Number(e.totalAmount)
          } else if (e.currency == 1) {
            count2 += Number(e.totalAmount)
          } else if (e.currency == 2) {
            count3 += Number(e.totalAmount)
          }
        })
      }
      return { count1, count2, count3 }
    },
    scenicAmount() {
      let count = 0
      if (this.order.scenicSpotDetails && this.order.scenicSpotDetails.length > 0) {
        this.order.scenicSpotDetails.forEach(e => {
          count +=
            Number(e.peakFullPriceNum) * Number(e.peakPriceFull) +
            Number(e.peakHalfPriceNum) * Number(e.peakPriceHalf) +
            Number(e.peakStudentNum) * Number(e.peakStudent) +
            Number(e.peakOldNum) * Number(e.peakOld) +
            Number(e.peakFreeNum) * Number(e.peakFree) +
            Number(e.offPeakFullPriceNum) * Number(e.offPeakPriceFull) +
            Number(e.offPeakHalfPriceNum) * Number(e.offPeakPriceHalf) +
            Number(e.offPeakStudentNum) * Number(e.offPeakStudent) +
            Number(e.offPeakOldNum) * Number(e.offPeakOld) +
            Number(e.offPeakFreeNum) * Number(e.offPeakFree)
        })
      }
      return count
    },
    restaurantAmount() {
      let count = 0
      if (this.order.restaurantDetails && this.order.restaurantDetails.length > 0) {
        this.order.restaurantDetails.forEach(e => {
          count += Number(e.guestStandard) * Number(e.guestCount) + Number(e.guideStandard) * Number(e.guideCount)
          count += Number(e.otherAmount)
        })
      }
      return count
    },
    hotelAmount() {
      let count = 0
      if (this.order.hotelDetails && this.order.hotelDetails.length > 0) {
        this.order.hotelDetails.forEach(e => {
          count += (Number(e.guideRoomAmount) + Number(e.guestRoomAmount)) * Number(e.days)
        })
      }
      return count
    },
    carAmount() {
      let count = 0
      if (this.order.carServiceFeeDetails && this.order.carServiceFeeDetails.length > 0) {
        this.order.carServiceFeeDetails.forEach(e => {
          count += Number(e.totalAmount)
        })
      }
      return count
    },
    shoppingAmount() {
      let count = 0
      if (this.order.wineFruitBasketDetails && this.order.wineFruitBasketDetails.length > 0) {
        this.order.wineFruitBasketDetails.forEach(e => {
          count += Number(e.totalAmount)
        })
      }
      return count
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    backOrder() {
      this.$confirm({
        title: '提示',
        content: '订单状态变更成"审核失败", 导游更新后需要重新审核，是否确认 ?',
        onOk: () => {
          this.$axios.post(`/guide/admin/teamCheckout/commonAudit`, {
            id: this.order.id,
            version: this.order.version,
          })
          this.init()
        },
        onCancel() {},
      })
    },
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.get('/guide/admin/operationLog/getList', {
          params: {
            checkoutId: this.order.id,
            pageNumber: _pageNumber,
            pageSize: _pageSize,
          },
        })
        this.countTotal = Number(res.count)
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    // 初审完成
    async examine1Ok() {
      if (this.examine.groupCostStatus == null) {
        return this.$message.error('请审核现收团款')
      } else {
        if (this.examine.groupCostStatus == 1 && !this.examine.groupCostReason) {
          return this.$message.error('请输入现收团款审核失败原因')
        }
      }
      if (this.examine.shoppingStatus == null) {
        return this.$message.error('请审核购物信息')
      } else {
        if (this.examine.shoppingStatus == 1 && !this.examine.shoppingReason) {
          return this.$message.error('请输入购物审核失败原因')
        }
      }
      if (this.examine.scenicSpotStatus == null) {
        return this.$message.error('请审核景点信息')
      } else {
        if (this.examine.scenicSpotStatus == 1 && !this.examine.scenicSpotReason) {
          return this.$message.error('请输入景点审核失败原因')
        }
      }
      //
      if (this.examine.restaurantStatus == null) {
        return this.$message.error('请审核餐厅信息')
      } else {
        if (this.examine.restaurantStatus == 1 && !this.examine.restaurantReason) {
          return this.$message.error('请输入餐厅审核失败原因')
        }
      }
      if (this.examine.wineFruitBasketStatus == null) {
        return this.$message.error('请审核酒水果篮信息')
      } else {
        if (this.examine.wineFruitBasketStatus == 1 && !this.examine.wineFruitBasketReason) {
          return this.$message.error('请输入酒水果篮审核失败原因')
        }
      }
      if (this.examine.hotelStatus == null) {
        return this.$message.error('请审核酒店信息')
      } else {
        if (this.examine.hotelStatus == 1 && !this.examine.hotelReason) {
          return this.$message.error('请输入酒店审核失败原因')
        }
      }
      if (this.examine.carServiceFeeStatus == null) {
        return this.$message.error('请审核车费、服务信息')
      } else {
        if (this.examine.carServiceFeeStatus == 1 && !this.examine.carServiceFeeReason) {
          return this.$message.error('请输入车费、服务审核失败原因')
        }
      }
      if (!this.order.guideFeeToReceive) {
        return this.$message.error('请填写应收导游费用(人民币)')
      }
      // if (!this.order.usdAmountToReceive) {
      //   return this.$message.error('请填写应收导游费用(美元)')
      // }
      // if (!this.order.krwAmountToReceive) {
      //   return this.$message.error('请填写应收导游费用(韩元)')
      // }
      this.examine.guideFeeToReceive = this.order.guideFeeToReceive
      this.examine.usdAmountToReceive = this.order.usdAmountToReceive
      this.examine.krwAmountToReceive = this.order.krwAmountToReceive
      this.examine.guideFeeToPay = this.order.guideFeeToPay
      const res = await this.$axios.post(`/guide/admin/teamCheckout/firstAudit`, this.examine)
      if (res.success) {
        this.$confirm({
          title: '审核完成',
          content: '初审完成, 请等待OP继续审核 ?',
          onOk: async () => {
            this.init()
          },
          onCancel: () => {
            this.init()
          },
        })
      }
    },
    examineInit() {
      this.examine.id = null
      this.examine.guideFeeToReceive = null
      this.examine.guideFeeToPay = null
      this.examine.groupCostStatus = null
      this.examine.groupCostReason = ''
      this.examine.shoppingStatus = null
      this.examine.shoppingReason = ''
      this.examine.scenicSpotStatus = null
      this.examine.scenicSpotReason = ''
      this.examine.restaurantStatus = null
      this.examine.restaurantReason = ''
      this.examine.wineFruitBasketStatus = null
      this.examine.wineFruitBasketReason = ''
      this.examine.hotelStatus = null
      this.examine.hotelReason = ''
      this.examine.carServiceFeeStatus = null
      this.examine.carServiceFeeReason = ''
      this.examine.version = null
    },
    // 2审完成
    async examine2Ok() {
      if (this.examine.groupCostStatus == null) {
        return this.$message.error('请审核现收团款')
      } else {
        if (this.examine.groupCostStatus == 1 && !this.examine.groupCostReason) {
          return this.$message.error('请输入现收团款审核失败原因')
        }
      }
      if (this.examine.shoppingStatus == null) {
        return this.$message.error('请审核购物信息')
      } else {
        if (this.examine.shoppingStatus == 1 && !this.examine.shoppingReason) {
          return this.$message.error('请输入购物审核失败原因')
        }
      }
      if (this.examine.scenicSpotStatus == null) {
        return this.$message.error('请审核景点信息')
      } else {
        if (this.examine.scenicSpotStatus == 1 && !this.examine.scenicSpotReason) {
          return this.$message.error('请输入景点审核失败原因')
        }
      }
      //
      if (this.examine.restaurantStatus == null) {
        return this.$message.error('请审核餐厅信息')
      } else {
        if (this.examine.restaurantStatus == 1 && !this.examine.restaurantReason) {
          return this.$message.error('请输入餐厅审核失败原因')
        }
      }
      if (this.examine.wineFruitBasketStatus == null) {
        return this.$message.error('请审核酒水果篮信息')
      } else {
        if (this.examine.wineFruitBasketStatus == 1 && !this.examine.wineFruitBasketReason) {
          return this.$message.error('请输入酒水果篮审核失败原因')
        }
      }
      if (this.examine.hotelStatus == null) {
        return this.$message.error('请审核酒店信息')
      } else {
        if (this.examine.hotelStatus == 1 && !this.examine.hotelReason) {
          return this.$message.error('请输入酒店审核失败原因')
        }
      }
      if (this.examine.carServiceFeeStatus == null) {
        return this.$message.error('请审核车费、服务信息')
      } else {
        if (this.examine.carServiceFeeStatus == 1 && !this.examine.carServiceFeeReason) {
          return this.$message.error('请输入车费、服务审核失败原因')
        }
      }
      if (!this.order.guideFeeToReceive) {
        return this.$message.error('请填写应收导游费用(人民币)')
      }
      if (!this.order.guideFeeToPay) {
        return this.$message.error('请填写应付导游费用')
      }
      this.examine.guideFeeToReceive = this.order.guideFeeToReceive
      this.examine.usdAmountToReceive = this.order.usdAmountToReceive
      this.examine.krwAmountToReceive = this.order.krwAmountToReceive
      this.examine.guideFeeToPay = this.order.guideFeeToPay
      const res = await this.$axios.post(`/guide/admin/teamCheckout/opAudit`, this.examine)
      if (res.success) {
        this.init()
      }
    },
    reasonOk() {
      this.examine[this.examineType] = this.reasonName
      this.reasonModal = false
    },
    selectLose(type) {
      this.examine[`${type}Status`] = 1
      this.examineType = `${type}Reason`
      this.reasonName = ''
      this.reasonModal = true
    },
    selectSuccess(type) {
      this.examine[type] = 0
    },

    async downloadFile() {
      const res = await this.$axios.get(`/guide/admin/teamCheckout/download/${this.$route.query.id}`)
      if (res.success) {
        window.open(res.data)
      }
    },
    getAmount() {
      let shoppingCount = 0
      let usAmount = 0
      let krwAmount = 0
      if (this.order.currentGroupCostDetails && this.order.currentGroupCostDetails.length > 0) {
        this.order.currentGroupCostDetails.forEach(e => {
          usAmount += Number(e.totalAmount) * Number(e.groupPeople)
        })
      }
      if (this.order.shoppingDetails && this.order.shoppingDetails.length > 0) {
        this.order.shoppingDetails.forEach(e => {
          if (e.currency == 0) {
            if (e.rebate) {
              shoppingCount += Number(e.totalAmount) * (Number(e.rebate) / 100)
            } else {
              shoppingCount += 0
            }
          }
          if (e.currency == 1) {
            usAmount += Number(e.totalAmount)
          }
          if (e.currency == 2) {
            krwAmount += Number(e.totalAmount)
          }
        })
      }
      const money = this.shopAmount.count1 < 0 ? this.shopAmount.count1 : 0
      const money1 = this.shopAmount.count1 > 0 ? this.shopAmount.count1 : 0
      this.order.guideFeeToReceive =
        Number(this.order.managementFee) +
        shoppingCount +
        Number(this.order.usdDeductAmount) * Number(this.order.usdExchange) +
        Number(this.order.krwDeductAmount) * Number(this.order.krwExchange) +
        money

      this.order.guideFeeToPay =
        this.scenicAmount + this.restaurantAmount + this.hotelAmount + this.carAmount + this.shoppingAmount + money1
      this.order.usdAmountToReceive = usAmount - this.order.usdDeductAmount
      this.order.krwAmountToReceive = krwAmount - this.order.krwDeductAmount
    },
    handleCancel() {
      this.rebateVisible = false
      this.imgVisible = false
      this.rebateVisible = false
    },
    async handleOk() {
      const obj = {
        checkoutId: this.$route.query.id,
        consumptionCheckoutVoList: this.order.shoppingDetails.map(v => {
          return {
            item: v.item,
            rebate: v.rebate,
          }
        }),
        version: this.order.version,
      }
      const res = await this.$axios.post(`/guide/admin/teamCheckout/shoppingRebate`, obj)
      if (res.success) {
        this.init()
      }
      this.rebateVisible = false
    },
    init() {
      this.examineInit()
      this.loadById(this.$route.query.id)
    },
    async loadById(id) {
      const res = await this.$axios.get(`/guide/admin/teamCheckout/getDetail/${id}`, {
        data: id,
      })
      this.order = res.data
      this.examine.id = this.order.id
      this.examine.guideFeeToReceive = this.order.guideFeeToReceive
      this.examine.guideFeeToPay = this.order.guideFeeToPay
      this.examine.version = this.order.version
      this.this.examine = Object.assign(this.examine, res.data)
      this.doQuery()
    },
    async goBack() {
      const res = await this.$axios.post(`/guide/admin/teamCheckout/closing`, {
        id: this.$route.query.id,
        guideFeeToReceive: this.order.guideFeeToReceive,
        guideFeeToPay: this.order.guideFeeToPay,
        version: this.order.version,
      })
      if (res.success) {
        this.init()
      }
    },
    saveRebate() {
      this.rebateVisible = true
    },
    doSave() {
      this.order.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            // 下载结账单
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.active {
  color: #ffffff;
  background: red;
}
.active1 {
  color: #ffffff;
  background: green;
}
.infoView-box {
  margin-top: 20px;
  .info-title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
    display: flex;
  }
  .info-content {
    position: relative;
    width: 100%;
    overflow: auto;
    .ant-form-item {
      margin-bottom: 0px;
      label {
        font-weight: bold;
      }
    }
  }
}
.operation-btns {
  margin-top: 24px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  .ant-btn {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.li-point {
  &::marker {
    color: #ffb831;
  }
}
</style>
